import { UnstyledButton } from "@mantine/core";
import css from "./MicChatDrawer.module.scss";

const MAX_VISIBLE_SOURCES = 6;

const getUniqueMeetingSources = (sources) => {
  if (!Array.isArray(sources)) return [];

  const seenMeetingIds = new Set();

  return sources.reduce((uniqueSources, source) => {
    const meetingId = source?.meetingId;
    if (!meetingId || seenMeetingIds.has(meetingId)) {
      return uniqueSources;
    }

    seenMeetingIds.add(meetingId);
    return [...uniqueSources, source];
  }, []);
};

const AssistantSourceBadges = ({ sources, onSelectSource }) => {
  const visibleSources = getUniqueMeetingSources(sources).slice(
    0,
    MAX_VISIBLE_SOURCES,
  );

  if (!visibleSources.length) return null;

  return (
    <div className={css.sourceBadges} aria-label="Referenced meetings">
      {visibleSources.map((source) => (
        <UnstyledButton
          key={source.meetingId}
          className={css.sourceBadge}
          onClick={() => onSelectSource?.(source)}
          title={source.meetingTitle || "Untitled meeting"}
        >
          {source.meetingTitle || "Untitled meeting"}
        </UnstyledButton>
      ))}
    </div>
  );
};

export default AssistantSourceBadges;
